var components
try {
  components = {
    uCellGroup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-cell-group/u-cell-group" */ "uview-ui/components/u-cell-group/u-cell-group.vue"
      )
    },
    uCellItem: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-cell-item/u-cell-item" */ "uview-ui/components/u-cell-item/u-cell-item.vue"
      )
    },
    yiGoodsCard: function () {
      return import(
        /* webpackChunkName: "components/yi-goods-card/yi-goods-card" */ "@/components/yi-goods-card/yi-goods-card.vue"
      )
    },
    yiSubmitBar: function () {
      return import(
        /* webpackChunkName: "components/yi-submit-bar/yi-submit-bar" */ "@/components/yi-submit-bar/yi-submit-bar.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
    uCheckbox: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-checkbox/u-checkbox" */ "uview-ui/components/u-checkbox/u-checkbox.vue"
      )
    },
    yiCouponItem: function () {
      return import(
        /* webpackChunkName: "components/yi-coupon-item/yi-coupon-item" */ "@/components/yi-coupon-item/yi-coupon-item.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }